// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import { useFlexFlagIsOn } from '@indeed/flex-feature-flags'

import { TrackingTrigger, TrackingProvider } from '@indeed/flex-tracking-context'

import PageView from 'syft-acp-core/components/PageView'
import WorkerStrikeDetails from 'syft-acp-core/entities/WorkerStrikes/WorkerStrikeDetails'
import { trackingEvents } from 'syft-acp-core/entities/WorkerStrikes/WorkerStrikeDetails/WorkerStrikeDetails.tracking'
import { SAVE_BUTTON_EVENT } from 'syft-acp-core/entities/WorkerStrikes/WorkerStrikeDetails/WorkerStrikeDetails.helpers'
import { recordLabel, useWorkerName } from 'syft-acp-core/components/PageTitle'

import { WorkerSubNavigation } from './SubNavigation'
import { RouteComponentProps } from 'react-router-dom'

type Props = RouteComponentProps<{
  id: string
  strikeID: string
}>

export const EntityWorkersStrikesView = ({ match: { params } }: Props) => {
  const workerName = useWorkerName(Number(params.id))
  const isNegativeAction = useFlexFlagIsOn('pte_34577_negative_actions')

  return (
    <TrackingProvider
      value={{
        context: {
          worker_id: params.id,
          strike_id: params.strikeID,
        },
        eventMappings: event => (event === SAVE_BUTTON_EVENT ? trackingEvents.SAVE_BUTTON.CLICKED : event),
      }}
    >
      <TrackingTrigger
        onLoad={{
          event: trackingEvents.PAGE.VIEWED,
        }}
      />
      <WorkerSubNavigation workerID={params.id} />,
      <PageView
        title={[
          `${isNegativeAction ? 'Negative action' : 'Strike'} ${params.strikeID}`,
          recordLabel('Worker', params.id, workerName),
        ]}
      >
        <WorkerStrikeDetails workerID={Number(params.id)} id={Number(params.strikeID)} />
      </PageView>
    </TrackingProvider>
  )
}
